import React from "react";
import { Asterisk } from "lucide-react";

export const CLAUDE_TONE = "bg-[#D97757]/10 text-[#B4532F] border border-[#D97757]/25";

export function ClaudeBadge({ testid, label = "Claude" }) {
  return (
    <span data-testid={testid} title="Made through the Claude connector"
      className={`inline-flex items-center gap-0.5 text-[10px] font-semibold px-1.5 py-0.5 rounded align-middle ${CLAUDE_TONE}`}>
      <Asterisk className="w-3 h-3" />{label}
    </span>
  );
}

export const ago = (iso) => {
  if (!iso) return "";
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.round(s / 60)} min ago`;
  if (s < 86400) return `${Math.round(s / 3600)} h ago`;
  return `${Math.round(s / 86400)} d ago`;
};

export const when = (iso) => {
  try { return new Date(iso).toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }); }
  catch { return ""; }
};
